// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { DateTime } from 'luxon'

// Internal Dependencies:
import Verse from './Verse'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import Calendar from 'components/Form/Calendar'
import { getDateAsYYYYMmDd } from 'utilities/time'

// Redux:
import { getScheduledVersesData, getVersesData } from 'actions/votd'

class VersesSchedule extends React.Component {
	constructor( props ) {
		super( props )

		const { params } = props.match
		const dateObject = ( params.date ) ? new Date( params.date ) : new Date()
		const dateAsYYYYMmDd = getDateAsYYYYMmDd( dateObject )

		this.state = {
			dateObject: dateObject,
			dateAsYYYYMmDd: dateAsYYYYMmDd
		}
	}

	componentDidMount() {
		const { dateAsYYYYMmDd } = this.state

		window.scrollTo( 0, siteData.page_top_pos )
		document.querySelector( '.main' ).scrollTop = 0

		this.props.getScheduledVersesData( dateAsYYYYMmDd )
		this.props.getVersesData( 'all' )
	}

	componentDidUpdate( prevProps, prevState ) {
		const { dateAsYYYYMmDd } = this.state

		if ( dateAsYYYYMmDd != prevState.dateAsYYYYMmDd ) {
			this.props.getScheduledVersesData( dateAsYYYYMmDd )
		}
	}

	handleDateChange = ( id, value ) => {
		this.setState({
			dateObject: value,
			dateAsYYYYMmDd: getDateAsYYYYMmDd( value )
		})
	}

	render() {
		const { scheduledVersesData, verses, timezone, scheduledVersesDataIsLoading, siteId, stationsById } = this.props
		const { dateObject, dateAsYYYYMmDd } = this.state
		let stationName

		if ( siteId && stationsById[ siteId ] ) {
			stationName = stationsById[ siteId ].name
		}

		const dateDisplay = DateTime.fromJSDate( dateObject ).toLocaleString( DateTime.DATE_FULL )
		const maxDate = new Date()
		maxDate.setDate( maxDate.getDate() + 2 )

		let hasScheduleRecordings = false

		if ( scheduledVersesData && scheduledVersesData[ dateAsYYYYMmDd ] && Object.keys( scheduledVersesData[ dateAsYYYYMmDd ] ).length ) {
			hasScheduleRecordings = true
		}

		let verseData,
			verseRecordLink

		if ( verses && verses.all && Object.keys( verses.all ).length ) {
			Object.keys( verses.all ).map( key => {
				if ( dateAsYYYYMmDd.indexOf( verses.all[ key ].date_month_day ) > -1 ) {
					verseData = verses.all[ key ]
					verseData.date_year_month_day = dateAsYYYYMmDd
					verseData.scheduled_recordings = false

					if ( hasScheduleRecordings ) {
						verseData.scheduled_recordings = scheduledVersesData[ dateAsYYYYMmDd ]
					}

					verseRecordLink = `/votd/${verses.all[ key ].date}`
				}
			})
		}

		let recordingsText = 'recording exists',
			hasRecordings = false

		if ( verseData && verseData.recordings_number ) {
			hasRecordings = true
		}

		if ( hasRecordings && verseData.recordings_number > 1 ) {
			recordingsText = 'recordings exist'
		}

		let markup = (
			<div className="-no-data">
				<p>
					{ hasRecordings &&
						<span>{ verseData.recordings_number } { recordingsText } for this verse, but schedule information is not yet available for this date.</span>
					||
						<span>No verses are recorded for this day.</span>
					}

					{ ( ! hasRecordings && verseRecordLink ) &&
						<span> <Link to={ verseRecordLink }>Why not record one?</Link></span>
					}
				</p>
			</div>
		)

		if ( hasScheduleRecordings ) {
			markup = Object.keys( scheduledVersesData[ dateAsYYYYMmDd ] ).map( key => {
				let item = scheduledVersesData[ dateAsYYYYMmDd ][ key ]

				return (
					<div className="-item" key={ key }>
						<div className="-time">
							{ item.time }
						</div>

						<div className="-initials">
							{ item.initials }

							{ item.number &&
								<span> ({ item.number })</span>
							}
						</div>

						<div className="-file">
							<a href={ item.file_url } target="_blank" rel="noopener">{ item.file_name }</a>
						</div>
					</div>
				)
			})
		}

		return (
			<div className="votd-schedule-wrap">
				<header>
					<div className="votd-schedule-title-wrap">
						<div className="votd-schedule-title">
							<h2>Showing schedule for { dateDisplay }</h2>

							{ stationName &&
								<p>Times shown for { stationName } station.  Times may be different for other stations.</p>
							}
						</div>

						<Verse data={ verseData } simple={ true } />
					</div>

					<div className="votd-schedule-calendar">
						<Calendar
							id=""
							value={ dateObject }
							onChange={ this.handleDateChange }
							maxDate={ maxDate }
						/>
					</div>
				</header>

				<main className="votd-schedule">
					<div className="-item">
						<div className="-time">
							Time
						</div>

						<div className="-initials">
							Speaker ID
						</div>

						<div className="-file">
							File
						</div>
					</div>

					{ scheduledVersesDataIsLoading &&
						<LoadingSpinner />
					}

					{ ! scheduledVersesDataIsLoading && markup }
				</main>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		scheduledVersesDataIsLoading: state.page.scheduledVersesDataIsLoading,
		scheduledVersesData: state.votd.scheduledVersesData,
		verses: state.votd.verses,
		timezone: state.schedule.timezone,
		siteId: state.schedule.siteId,
		stationsById: state.schedule.stationsById,
		isMobile: state.site.isMobile
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getScheduledVersesData( dateAsYYYYMmDd ) {
			dispatch( getScheduledVersesData( dateAsYYYYMmDd ) )
		},

		getVersesData( date ) {
			dispatch( getVersesData( date ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( VersesSchedule )
